import "../css/App.css";
import "../css/Toast.css";
import * as React from "react";
import { render } from "react-dom";
import Toast from "./Toast";
import "regenerator-runtime";
import Simulator from "./Simulator";

const App = () => {
  Toast("Namaste 🙏");
  return (
    <div id="app">
      <Simulator fps={30}></Simulator>
    </div>
  );
};

render(<App />, document.getElementById("root"));
